<script setup lang="ts">
type Props = {
  hideClearButton?: boolean;
  isDisabled?: boolean;
};

defineProps<Props>();

type Emits = {
  (e: "apply-filters"): void;
  (e: "clear-filters"): void;
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div class="filter-control-buttons">
    <slot>
      <BaseButton
        v-if="!hideClearButton"
        class="w-full"
        color-scheme="transparent"
        :disabled="isDisabled"
        data-test="clear-filters"
        @click="emit('clear-filters')"
      >
        {{ $t("filter.clearFilters") }}
      </BaseButton>
      <BaseButton
        class="w-full"
        :disabled="isDisabled"
        @click="emit('apply-filters')"
      >
        {{ $t("filter.applyFilters") }}
      </BaseButton>
    </slot>
  </div>
</template>

<style lang="postcss" scoped>
.filter-control-buttons {
  @apply sticky bottom-0 w-full bg-platform-bg-1 left-0 p-4;
  @apply flex flex-row gap-2;
  @apply border-t;
}
</style>
